export default __webpack_public_path__ + "static/media/lsLogo.b49acd18.png";